module.exports = __webpack_public_path__ + "static/2018-AJCO-f05f014f8f59694be7225a97a5120f47.pdf";